import * as Yup from 'yup';
import { getRequiredText } from '../../../../../global/helpers/transformer';
import { LabelSettingProps } from '../../../../../global/models/epi-model';
import { TerminationProps } from '../../../models/arc-epi-props';
import { TerminationTypes } from './employment-termination-model';

export enum EmploymentCombinationTypes {
	Terminated = 'Terminated',
	Stipendiary = 'stipendiary',
	NonStipendiary = 'non_stipendiary',
	StipAndNonStip = 'StipAndNonStip',
}

export interface TerminationFormValues {
	termination_type: string;
	termination_date: string;
	person_retiring_indicator: string;
	extenuating_circumstances: string;
	employment_types: EmploymentCombinationTypes[];
	acknowledge: boolean;
}

export function terminationFormValidationSchema(labelSettings: LabelSettingProps, terminationProps: TerminationProps, apiErrors: any) {

	return Yup.lazy(({ termination_type }) => {
		let schema = Yup.object().shape({
			termination_type: Yup.string().required(getRequiredText(labelSettings.requiredFormat, terminationProps?.terminationTypeLabel)),
			person_retiring_indicator: Yup.string().when(['termination_type', 'termination_date', 'employment_types'], {
				is: (a, b, c) => a === TerminationTypes.Employment && b && !(c?.length === 1 && c[0] === EmploymentCombinationTypes.NonStipendiary),
				then: Yup.string().required(terminationProps.isRetiringLabel),
			}),
		});

		if (termination_type === TerminationTypes.Employment || termination_type === TerminationTypes.Death) {
			const terminationDateLabel = termination_type === TerminationTypes.Employment ? terminationProps?.lastDayWorkedLabel : terminationProps?.dateOfDeathLabel;
			schema = schema.shape({
				termination_date: Yup.date().nullable().required(getRequiredText(labelSettings.requiredFormat, terminationDateLabel))
					.test('termination_date', (value, context) => value && context && apiErrors && apiErrors.termination_date ? context.createError({ message: apiErrors.termination_date }) : true),
			});
		}

		if (termination_type === TerminationTypes.Employment) {
			schema = schema.shape({
				employment_types: Yup.array().min(1, getRequiredText(labelSettings.requiredFormat, terminationProps?.employmentTypeLabel)),
			});
		}

		if (termination_type === TerminationTypes.LeaveOfAbsence) {
			schema = schema.shape({
				termination_date: Yup.date().nullable().required(getRequiredText(labelSettings.requiredFormat, terminationProps?.effectiveDateLabel))
					.test('termination_date', (value, context) => value && context && apiErrors && apiErrors.termination_date ? context.createError({ message: apiErrors.termination_date }) : true),
				acknowledge: Yup.boolean().oneOf([true], terminationProps?.leaveOfAbsenceAcknowledgeRequiredMessage),
			});
		}

		return schema;
	});

}